import { getToken, refreshToken } from './keycloak';

export default function initFetchInterceptor() {
    const originalFetch = window.fetch;
    const apiBaseUrl = import.meta.env.VITE_REACT_APP_API_BASE_URL;

    // Create a fetch interceptor
    window.fetch = async function (resource, options = {}) {
        try {
            let url;
            let requestOptions = options;
            
            // Handle both string URLs and Request objects
            if (resource instanceof Request) {
                url = resource.url;
                // Create new options merging the Request and provided options
                requestOptions = {
                    ...options,
                    method: resource.method,
                    headers: {
                        ...Object.fromEntries(resource.headers.entries()),
                        ...options.headers
                    },
                    // Other Request properties as needed
                    credentials: resource.credentials,
                    mode: resource.mode,
                    cache: resource.cache,
                };
            } else {
                url = resource;
            }
            
            // Check if this is an internal API call to Henddus' backend
            const isInternalApi = typeof url === 'string' && url.includes(apiBaseUrl);
            
            // Check if this is a public route (no Keycloak auth needed)
            const isPublicRoute = typeof window !== 'undefined' && window.location.pathname.startsWith('/website');
            
            // Only process authentication for internal APIs that are NOT on public routes
            if (isInternalApi && !isPublicRoute) {
                // Try to refresh the token before making request to internal API
                await refreshToken();
                
                // Get the current token
                const token = getToken();
                
                // Prepare headers with authentication
                const existingHeaders = requestOptions.headers || {};
                const headers = { ...existingHeaders };
                
                if (token) {
                    headers.Authorization = `Bearer ${token}`;
                }
                
                // Only add Accept header if not already set
                if (!headers.Accept) {
                    headers.Accept = 'application/json';
                }
                
                // Only add Content-Type for non-FormData requests
                // FormData needs browser to set Content-Type with boundary
                const hasFormData = requestOptions.body instanceof FormData;
                if (!headers['Content-Type'] && !hasFormData) {
                    headers['Content-Type'] = 'application/json';
                }
                
                // Merge with original options for internal APIs
                const updatedOptions = {
                    ...requestOptions,
                    headers
                };
                
                // Make the request with the intercepted fetch for internal APIs
                return originalFetch(url, updatedOptions);
            } else {
                // For external APIs or non-string resources, use original fetch
                return originalFetch(resource, options);
            }
        } catch (error) {
            console.error('Fetch interceptor error:', error);
            return Promise.reject(error);
        }
    };
}